import { io } from "socket.io-client";
import { getSupportticketSocketUrl } from "./supportticketBase";

const SOCKET_NAMESPACE = "/ticket-chat";

const normalizeRoomPayload = (payload) => ({
  companyId: Number(payload?.companyId),
  supportTicketId: Number(payload?.supportTicketId),
});

export const createTicketRoom = (companyId, supportTicketId) =>
  `ticket:${companyId}:${supportTicketId}`;

export const createTicketChatSocket = ({
  token,
  onConnect,
  onDisconnect,
  onReconnect,
  onReconnectAttempt,
  onJoined,
  onMessage,
  onTicketError,
}) => {
  const socket = io(getSupportticketSocketUrl(SOCKET_NAMESPACE), {
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    transports: ["websocket", "polling"],
    auth: { token },
  });

  let activeRoomPayload = null;

  socket.on("connect", () => {
    if (typeof onConnect === "function") onConnect();
    if (activeRoomPayload) {
      socket.emit("ticket:join", activeRoomPayload);
    }
  });

  socket.on("disconnect", (reason) => {
    if (typeof onDisconnect === "function") onDisconnect(reason);
  });

  socket.io.on("reconnect_attempt", (attempt) => {
    if (typeof onReconnectAttempt === "function") onReconnectAttempt(attempt);
  });

  socket.io.on("reconnect", (attempt) => {
    if (typeof onReconnect === "function") onReconnect(attempt);
    if (activeRoomPayload) {
      socket.emit("ticket:join", activeRoomPayload);
    }
  });

  socket.on("ticket:joined", (payload) => {
    if (typeof onJoined === "function") onJoined(payload);
  });

  socket.on("ticket:message", (payload) => {
    if (typeof onMessage === "function") onMessage(payload);
  });

  socket.on("ticket:error", (payload) => {
    if (typeof onTicketError === "function") onTicketError(payload);
  });

  return {
    connect() {
      if (!socket.connected) socket.connect();
    },
    joinRoom(payload) {
      const normalized = normalizeRoomPayload(payload);
      activeRoomPayload = normalized;
      if (socket.connected) socket.emit("ticket:join", normalized);
    },
    leaveRoom(payload) {
      const normalized = normalizeRoomPayload(payload);
      socket.emit("ticket:leave", normalized);
      if (
        activeRoomPayload &&
        Number(activeRoomPayload.companyId) === Number(normalized.companyId) &&
        Number(activeRoomPayload.supportTicketId) === Number(normalized.supportTicketId)
      ) {
        activeRoomPayload = null;
      }
    },
    sendMessage(payload) {
      socket.emit("ticket:send", payload);
    },
    isConnected() {
      return socket.connected;
    },
    disconnect() {
      if (socket.connected && activeRoomPayload) {
        socket.emit("ticket:leave", activeRoomPayload);
      }
      activeRoomPayload = null;
      socket.removeAllListeners();
      socket.disconnect();
    },
  };
};
